/**
 * 
 * key
 * 
 */


const key = 'cGF5bWVudF9tb2Rl'

export default key 